import { useEffect, useState } from "react";

import Autocomplete, { autocompleteClasses } from "@mui/material/Autocomplete";
import InputBase from "@mui/material/InputBase";
import Popover from "@mui/material/Popover";
import { styled } from "@mui/material/styles";

type FilterAutocompleteProps = {
  open: boolean;
  onSelect: (value: { label: string; filterKey: string } | null) => void;
  onClose: () => void;
  anchorEl: null | HTMLElement;
  options: Array<{
    label: string;
    filterKey: string;
  }>;
};

const StyledPopover = styled(Popover)(({ theme }) => ({
  [`& .${autocompleteClasses.paper}`]: {
    marginTop: "9px"
  }
}));

const paperSx = {
  px: 1.5,
  py: 1,
  border: "solid 1px #ccc",
  overflow: "visible",
  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
  mt: 1.5,
  "& .MuiAvatar-root": {
    width: 32,
    height: 32,
    ml: -0.5,
    mr: 1
  },
  "&:before": {
    content: '""',
    display: "block",
    position: "absolute",
    top: 0,
    left: 14,
    width: 10,
    height: 10,
    bgcolor: "background.paper",
    transform: "translateY(-50%) rotate(45deg)",
    zIndex: 0
  }
};

export default function FilterAutocomplete({
  options,
  open,
  onClose,
  onSelect,
  anchorEl
}: FilterAutocompleteProps) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (ready) {
      document.getElementById("custom-filter-search-input")?.focus();
    }
  }, [ready]);

  const handleClose = () => {
    setReady(false);
    onClose();
  };

  return (
    <StyledPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      PaperProps={{
        elevation: 0,
        sx: paperSx
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
    >
      <Autocomplete
        id="custom-filter-search-input"
        onOpen={(e) => {
          setReady(true);
        }}
        onClose={() => {
          setReady(false);
        }}
        onChange={(event, value, reason) => {
          if (reason === "selectOption" && value) {
            onSelect(value);
            handleClose();
          }
        }}
        blurOnSelect
        autoHighlight
        openOnFocus
        options={options}
        sx={{ width: 300 }}
        disablePortal
        renderInput={({ InputLabelProps, InputProps, ...params }) => {
          return (
            <InputBase
              {...InputProps}
              {...params}
              autoFocus
              endAdornment={null}
              placeholder="Select a filter"
            />
          );
        }}
      />
    </StyledPopover>
  );
}
